import { render } from "./SwitchLocaleComponent.vue?vue&type=template&id=e3f20276&scoped=true"
import script from "./SwitchLocaleComponent.vue?vue&type=script&lang=js"
export * from "./SwitchLocaleComponent.vue?vue&type=script&lang=js"

import "./SwitchLocaleComponent.vue?vue&type=style&index=0&id=e3f20276&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3f20276"]])

export default __exports__